<template>
  <SelectWithSearch
    label="Unidade de medida"
    id="autocomplete-unit-of-measure-default"
    v-model="input"
    :options="search"
    :search="onSearch"
    :change="change"
    :disabled="disabled"
    :clearable="false"
    :error="error"
    labelBusca="name"
    propsToShow="name"
  >
    <template slot="options" slot-scope="props">
      <div class="selected">{{ props.data.name }}</div>
    </template>
    <template slot="no-options"> Selecione uma unidade de medida </template>
    <template slot="selected" slot-scope="props">
      <div class="selected">{{ props.data.name }}</div>
    </template>
  </SelectWithSearch>
</template>

<script>
import SearchMixin from '@/core/mixins/SearchMixin';
import { SelectWithSearch } from '@/components/Form';
import { mapState } from 'vuex';

export default {
  name: 'AutocompleteUnitOfMeasure',
  components: {
    SelectWithSearch,
  },
  mixins: [SearchMixin],
  props: {
    value: {},
    defaultUn: {
      type: Boolean,
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      collectionUnitOfMeasure: [],
      search: [],
      input: undefined,
    };
  },
  watch: {
    value(current) {
      this.input = current;
    },
  },
  computed: {
    ...mapState('service', ['service']),
  },
  async mounted() {
    await this.getUnitOfMeasure();

    if (this.service.unitOfMeasureId) {
      const { unitOfMeasureId } = this.service;
      const unitOfMeasure = this.collectionUnitOfMeasure.find(
        (e) => e.id === unitOfMeasureId,
      );

      this.$emit('input', unitOfMeasure);
    }
  },
  methods: {
    async getUnitOfMeasure() {
      const { data } = await this.$http.post('inventory.get-unit_of_measure', {
        active: true,
        converter: 1,
      });

      if (this.defaultUn && !this.input) {
        const un = data.find((item) => item.acronym === 'UN');
        this.$emit('input', un);
      }

      this.collectionUnitOfMeasure = data;
      this.search = data;
    },
    onSearch(value) {
      this.search = this.searchCollection(
        this.collectionUnitOfMeasure,
        value,
        'name',
      );
    },
    change(value) {
      this.$emit('input', value);
    },
  },
};
</script>
